import styled from 'styled-components';

export const ChatContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  max-width: 800px;
  max-height: ${props => props.noBanner ? '85vh' : '63vh'};
  height: ${props => props.noBanner ? '85vh' : 'auto'};
  background: rgb(41, 40, 40);
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  z-index: 1000;

  @media (max-width: 600px) {
    width: 95%;
    max-height: ${props => props.noBanner ? '88vh' : '75vh'};
    height: ${props => props.noBanner ? '88vh' : 'auto'};
  }
`;

export const MainContainer = styled.div`
  width: 100%;
  height: ${props => props.noBanner ? '0' : '80vh'};
  max-width: 900px;
  margin: 0 auto;
  padding: 0;

  @media (max-width: 768px) {
    padding: 0;
    height: ${props => props.noBanner ? '0' : '10vh'};
    margin: 0;
    max-width: 100%;
    position: ${props => props.noBanner ? 'static' : 'fixed'};
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: ${props => props.noBanner ? '0' : '100%'};
  background: ${props => props.noBanner ? 'transparent' : 'rgb(41, 40, 40)'};
  gap: ${props => props.noBanner ? '0' : '12px'};

  @media (max-width: 768px) {
    height: ${props => props.noBanner ? '0' : '90vh'};
    gap: 0;
  }
`;

export const CarouselContainer = styled.div.attrs({ className: 'ads-banner' })`
  width: 100%;
  background: rgb(41, 40, 40);
  padding: 8px;
  height: 18vh;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 8px;
  }

  @media (max-width: 768px) {
    height: 15vh;
    padding: 5px;

    img {
      border-radius: 4px;
    }
  }
`;

export const ChatHeader = styled.div`
  background: rgb(0, 0, 0);
  color: white;
  padding: 10px 14px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
`;

export const BackButton = styled.button`
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: rgba(255, 255, 255, 0.85);
  width: 36px;
  height: 36px;
  border-radius: 10px;
  font-size: 1.1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  transition: background 0.2s ease, border-color 0.2s ease;

  &:hover {
    background: rgba(255, 153, 0, 0.15);
    border-color: rgba(255, 153, 0, 0.5);
  }

  &:focus-visible {
    outline: 2px solid var(--primary-color);
    outline-offset: 2px;
  }
`;

export const ChatAvatar = styled.div`
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background-image: url(${props => props.image || '/images/default-avatar.png'});
  background-size: cover;
  background-position: center;
  background-color: rgba(255, 153, 0, 0.15);
  border: 1.5px solid rgba(255, 153, 0, 0.5);
  margin-right: 12px;
  flex-shrink: 0;
  image-rendering: pixelated;
  image-rendering: -moz-crisp-edges;
  image-rendering: crisp-edges;
`;

export const ChatTitle = styled.div`
  flex: 1;
  color: var(--white-color);
  text-align: left;
  font-weight: normal;
  font-size: 16px;
`;

export const ChatMessages = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 10px;
  padding-bottom: 80px;
`;

export const ChatInputContainer = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  padding: 10px;
  background: rgb(41, 40, 40);
  border-top: 1px solid #333;
`;

export const ChatTextarea = styled.textarea`
  flex: 1;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-right: 10px;
  resize: none;
  min-height: 40px;
`;

export const ChatButton = styled.button`
  background: rgb(247, 144, 0);
  color: white;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;

  &:hover {
    background: rgb(249, 178, 55);
    transform: scale(1.1);
  }
  
  &:active {
    transform: scale(0.95);
  }
`;

export const AudioButtonContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const AudioButton = styled.button`
  background: ${({ isRecording }) => isRecording ? '#ff4444' : '#4CAF50'};
  color: white;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  
  &:hover {
    background: ${({ isRecording }) => isRecording ? '#cc0000' : '#45a049'};
    transform: scale(1.1);
  }
  
  &:disabled {
    background: #cccccc;
    cursor: not-allowed;
    transform: none;
  }
  
  &:active {
    transform: scale(0.95);
  }
  
  /* Animação para o spinner de loading */
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

export const ProgressContainer = styled.div`
  position: absolute;
  bottom: 60px;
  left: 10px;
  right: 10px;
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 8px 12px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 12px;
`;

export const ProgressBar = styled.div`
  width: 100%;
  height: 4px;
  background: #333;
  border-radius: 2px;
  overflow: hidden;
  
  &::after {
    content: '';
    display: block;
    height: 100%;
    width: ${({ progress }) => progress}%;
    background: #4CAF50;
    transition: width 0.3s ease;
  }
`;

export const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Message = styled.div`
  align-self: ${({ isUser }) => (isUser ? 'flex-end' : 'flex-start')};
  background: ${({ isUser }) => (isUser ? 'rgba(255, 153, 0, 0.18)' : 'rgba(255, 255, 255, 0.08)')};
  border: 1px solid ${({ isUser }) => (isUser ? 'rgba(255, 153, 0, 0.35)' : 'rgba(255, 255, 255, 0.12)')};
  color: ${({ isUser }) => (isUser ? '#ffffff' : 'rgba(255, 255, 255, 0.92)')};
  padding: 10px 14px;
  border-radius: 16px;
  border-bottom-right-radius: ${({ isUser }) => (isUser ? '4px' : '16px')};
  border-bottom-left-radius: ${({ isUser }) => (isUser ? '16px' : '4px')};
  max-width: 80%;
  word-wrap: break-word;
  line-height: 1.5;
  margin-bottom: 5px;

  & > strong:first-of-type {
    color: ${({ isUser }) => (isUser ? 'rgb(255, 184, 79)' : 'rgb(255, 153, 0)')};
    margin-right: 4px;
  }

  strong {
    font-weight: 700;
    color: ${({ isUser }) => (isUser ? '#ffffff' : 'rgb(255, 200, 130)')};
  }

  em {
    font-style: italic;
    color: ${({ isUser }) => (isUser ? 'rgba(255, 255, 255, 0.92)' : 'rgba(255, 255, 255, 0.85)')};
  }

  /* Pensamento do personagem — itálico suave e discreto (não rouba a cena) */
  .thought {
    font-style: italic;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.5);
  }

  ul {
    padding-left: 18px;
    margin: 8px 0;
  }

  li {
    margin: 4px 0;
    list-style: disc;
  }

  a {
    color: rgb(255, 184, 79);
    text-decoration: underline;
    word-break: break-all;

    &:hover {
      color: rgb(255, 200, 130);
    }
  }

  code {
    background: rgba(0, 0, 0, 0.3);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 4px;
    padding: 1px 6px;
    font-family: 'Courier New', monospace;
    font-size: 0.92em;
    color: rgb(255, 200, 130);
  }
`;

export const AdCarousel = styled.div`
  width: 300px;
  margin-left: 20px;
  
  .slick-slide img {
    width: 100%;
    height: auto;
    border-radius: 8px;
  }
  
  .slick-dots {
    bottom: -25px;
  }
  
  .slick-prev, .slick-next {
    z-index: 1;
  }
`; 